// Monthly/yearly billing toggle — every plan card carries data-monthly /
// data-yearly and its [data-plan-price] gets swapped together.
export function initPricingToggle(): void {
  const section = document.querySelector<HTMLElement>('[data-pricing]');
  if (!section) return;

  const buttons = Array.from(section.querySelectorAll<HTMLButtonElement>('[data-billing]'));
  const cards = Array.from(section.querySelectorAll<HTMLElement>('[data-plan]'));
  if (!buttons.length || !cards.length) return;

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const billing = btn.dataset.billing === 'yearly' ? 'yearly' : 'monthly';
      buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
      cards.forEach((card) => {
        const price = card.querySelector<HTMLElement>('[data-plan-price]');
        if (price) price.textContent = card.dataset[billing] || '';
      });
    });
  });
}
